module.exports = __webpack_public_path__ + "svg/cogwheel.5916321ddfb8748992fef00608a4618d.svg";